import { setStorage,nestedFind } from '@/utils'
import { login, XZHLogin } from '../../api/databaseBin'
// import Router from '@/router/index'

// import { login } from '@/api/databaseBin'
const state = {
  useNewGovTemplate: false
}
const getters = {
  getUseNewGovTemplate: state => state.useNewGovTemplate
}
const mutations = {
  setUseNewGovTemplate(state, useNewGovTemplate) {
    state.useNewGovTemplate = useNewGovTemplate
  }
}
const actions = {
  LoginForm(context, form) {
    const Base64 = require('js-base64').Base64
    return new Promise((resolve, reject) => {
      const params = {
        tenantId: ''
      }
      if (form.tenantId === 'undefined') {
        params.tenantId = ''
      } else {
        params.tenantId = form.tenantId
      }
      const { code, account } = form
      const userAccount = code ? `yk_${code}` : account
      const password = '123456'
      const data = {
        username: userAccount || '',
        password: Base64.encode(password)
      }
      login(params, data).then(res => {
        if (res.loginStatus) {
          setStorage('token', res.token, 0)

          resolve(res)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },

  XZSLogin(ctx, params) {
    const { code } = params
    const Base64 = require('js-base64').Base64
    return new Promise((resolve, reject) => {
      params.username = 'yk_' + code
      params.loginType = '1'
      // if (code !== 'ourchem') {
      //   params.username = 'yk_' + code
      // }
      const password = '123456'
      params.password = Base64.encode(password)
      XZHLogin(params).then(res => {
        if (res.code === 200) {
          setStorage('token', res.data.token, 0)
          if (params.typeCode === 'government' && res.data.userAttrs && res.data.userAttrs.menus && nestedFind(res.data.userAttrs.menus, item => item.perms === '/digitalScreen')) {
            ctx.commit('user/setUseNewGovTemplate', true, {
              root: true
            })
            const newGovTemplateTitle = {
              title: '战略新兴产业专利统计',
              title2: '专利代理所统计',
              title3: '专利权人专利统计'
            }
            Object.entries(newGovTemplateTitle).forEach(([key, value]) => {
              ctx.commit('title/setTitle', { key, value }, {
                root: true
              })
            })
          } else {
            ctx.commit('user/setUseNewGovTemplate', false, {
              root: true
            })
            const oldGovTemplateTitle = {
              title2: '',
              title3: ''
            }
            Object.entries(oldGovTemplateTitle).forEach(([key, value]) => {
              ctx.commit('title/setTitle', { key, value }, {
                root: true
              })
            })
          }
          resolve(res)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
